import { buildProps, definePropType } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'

import { IconProps } from '../../icon'
import CollapsePanel from './collapse-panel.vue'
import Collapse from './collapse.vue'

export const collapseProps = buildProps({
  expandIcon: {
    type: String,
    default: '',
  },
} as const)

// 面板
export const collapsePanelProps = buildProps({
  //  图标信息
  headerIcon: {
    type: definePropType<IconProps>(Object),
    default: () => ({
      iconName: undefined,
      color: undefined,
      size: undefined,
    }),
  },
  // 标题
  header: {
    type: String,
    default: '',
  },
  // 标题与图标间距
  iconSpace: {
    type: Number,
    default: 8,
  },
  // 是否显示右侧额外插槽
  showExtraSlot: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type CollapseProps = ExtractPropTypes<typeof collapseProps>
export type CollapsePanelProps = ExtractPropTypes<typeof collapsePanelProps>

// 导出cascader实列类型
export type CollapseInstance = InstanceType<typeof Collapse>
export type CollapsePanelInstance = InstanceType<typeof CollapsePanel>
